var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',_vm._g(_vm._b({attrs:{"background-color":(_vm.outlined ? 'white' : ''),"items":_vm.userGroupSelectItems,"rules":_vm.rules}},'v-select',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }